import React from 'react';
import classNames from 'classnames';
import EditorActions from 'components/RichTextEditorField/utils/EditorActions';
import { NEW_WINDOW_PROPS } from 'data/global';
import { useSlateStatic, useSelected, useFocused } from 'slate-react';

type LinkElementProps = {
  className?: string;
  href: string;
} & Record<string, any>;

const LinkElement: React.FC<LinkElementProps> = (props) => {
  const { children, className, href, ...rest } = props;

  const editor = useSlateStatic();
  const selected = useSelected();
  const focused = useFocused();

  const classes = classNames('anys-rich-text-editor__link-element', className);

  return (
    <div {...rest} className={classes}>
      <a href={href} onClick={(e) => e.stopPropagation()} {...NEW_WINDOW_PROPS}>
        {children}
      </a>
      {selected && focused && (
        <div
          className="anys-rich-text-editor__link-element__popup"
          contentEditable={false}
        >
          <a href={href} {...NEW_WINDOW_PROPS}>
            {href}
          </a>
          <button
            type="button"
            onClick={() => EditorActions.removeLink(editor)}
          >
            X
          </button>
        </div>
      )}
    </div>
  );
};

export default LinkElement;
